import React, { useEffect, useState } from 'react';
import { Table, Container, Row, Col, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import DemoBanner from '../components/DemoBanner';
import BrandImage from '../components/BrandImage';
import { DICT } from '../utils/dictionary';
import { API_BASE, getAuthHeaders } from '../utils/api'; // Importação do Gateway

// --- MOCK DATA PROFISSIONAL (Modo Demonstração) ---
const DEMO_METAS = [
  { id: 1, tier: 'Bronze', views_minimas: 100000, valor_bonus: 50.00, dias_maximos: 30 },
  { id: 2, tier: 'Prata', views_minimas: 250000, valor_bonus: 100.00, dias_maximos: 30 },
  { id: 3, tier: 'Ouro', views_minimas: 500000, valor_bonus: 250.00, dias_maximos: 30 },
  { id: 4, tier: 'Diamante', views_minimas: 1000000, valor_bonus: 500.00, dias_maximos: 45 },
];

const Metas = () => {
  const { user, logout, isDemo, token } = useAuth();
  const [metas, setMetas] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchMetas = async () => {
      // --- MODO DEMONSTRAÇÃO ---
      if (isDemo) {
        setMetas(DEMO_METAS);
        return;
      }

      // --- MODO PRODUÇÃO ---
      if (!token || !user?.cargo) {
        return;
      }

      try {
        const res = await fetch(`${API_BASE}/metas_bonus?somente_do_usuario=true`, {
          headers: getAuthHeaders(token), // Uso dos headers centralizados
        });

        if (res.status === 401) {
          logout();
          return;
        }

        if (!res.ok) throw new Error(`Erro HTTP ${res.status}`);

        const data = await res.json();
        setMetas(Array.isArray(data) ? data : []);
      } catch (err) {
        setError('Erro ao buscar metas: ' + err.message);
      }
    };

    fetchMetas();
  }, [user, logout, isDemo, token]);

  return (
    <Container fluid className="main-content">
      {isDemo && <DemoBanner />}
      <Row className="align-items-center mb-4">
        <Col xs={12} md={6}>
          <h2 style={{ color: 'var(--brand-secondary)' }}>
            <i className="bi bi-bullseye me-2" style={{ color: 'var(--brand-primary)' }}></i> Minhas Metas
          </h2>
        </Col>
        <Col xs={12} md={6} className="text-md-end d-none d-md-block">
          <BrandImage 
            envKey="REACT_APP_BANNER_METAS"
            defaultAsset="/client_assets/finger_athos.png" 
            alt="Identidade Visual Metas"
            style={{ maxWidth: 150, height: 'auto' }} 
          />
        </Col>
      </Row>

      {error && (
        <Alert variant="danger" className="shadow-sm border-0">
          <i className="bi bi-exclamation-triangle me-2"></i> {error}
        </Alert>
      )}

      {metas.length === 0 && !error ? (
        <Alert variant="info" className="shadow-sm border-0">
          <i className="bi bi-info-circle me-2"></i> Nenhuma meta configurada para o seu cargo no momento.
        </Alert>
      ) : (
        <div className="card border-0 shadow-sm">
          <div className="card-body p-4">
            <h5 className="mb-4" style={{ color: 'var(--brand-secondary)' }}>
              <i className="bi bi-list-check me-2"></i>
              Tiers configuradas para o cargo: <strong style={{ color: 'var(--brand-primary)', textTransform: 'uppercase' }}>
                {isDemo ? (DICT.CARGOS_ETAPAS[0] || 'ESPECIALISTA') : user?.cargo}
              </strong>
            </h5>

            <div className="table-responsive">
              <Table striped hover className="align-middle mb-0">
                <thead style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-text-on-dark)' }}>
                  <tr>
                    <th className="border-0">Tier</th>
                    <th className="border-0">Métrica Mínima</th>
                    <th className="border-0">Valor ({DICT.REWARD})</th>
                    <th className="border-0">Prazo de Resgate</th>
                  </tr>
                </thead>
                <tbody>
                  {metas.map((meta) => (
                    <tr key={meta.id}>
                      <td className="fw-bold">{meta.tier}</td>
                      <td>
                        {meta.views_minimas.toLocaleString('pt-BR')}{' '}
                        <small className="text-muted">{DICT.METRIC_PLUR.toLowerCase()}</small>
                      </td>
                      <td className="fw-bold" style={{ color: 'var(--brand-primary)' }}>
                        {meta.valor_bonus.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                      </td>
                      <td>Até {meta.dias_maximos} dias úteis</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default Metas;